module.exports = "/hide-password-selected6b9ab9b6741b648c275101bcecc98def.svg";